import axios from '../config/axios';

const crearDocumento = async (idDocumentos) => {
  return await axios.post('/documentos/api/v1/crear_documento', {
      id: idDocumentos
    })
    .then((res) => res.data)
    .catch((err) => err);
}
const SubirArchivo = async (archivos, documento, nombrePaciente, key, id) => {
  var formData = new FormData();
  
  archivos.forEach(archivo => {
      formData.append("archivos", archivo);
  });
  
  formData.append("documento", documento);
  formData.append("nombrePaciente", nombrePaciente);
  formData.append("key", key);
  formData.append("id", id);

  return axios({
      method: 'POST',
      url: '/documentos/api/v1/subir_archivo',
      data: formData,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    })
    .then(result => {
      if (result && result.response && (result.response.status === 400 || result.response.status === 500)) {
        return result.response;
      }
      return result;
    })
    .catch((err) => err);
}
const descargarDocumento = async (id) => {
  return await axios.post('/documentos/api/v1/leer_archivo', {
      id
    })
    .then((res) => res.data)
    .catch((err) => err);
}
const SubirArchivoFormulario = async (archivos, documento, nombrePaciente, key, id, coleccion) => {
  var formData = new FormData();
  
  archivos.forEach(archivo => {
      formData.append("archivos", archivo);
  });
  
  formData.append("documento", documento);
  formData.append("nombrePaciente", nombrePaciente);
  formData.append("key", key);
  formData.append("id", id);
  formData.append("coleccion", coleccion);
  
  return axios({
      method: 'POST',
      url: '/documentos/api/v1/subir_archivo_formulario',
      data: formData,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    })
    .then(result => {
      if (result && result.response && (result.response.status === 400 || result.response.status === 500)) {
        return result.response;
      }
      return result;
    })
    .catch((err) => err);
}
const descargarDocumentoFormulario = async (id, coleccion) => {
  return await axios.post('/documentos/api/v1/leer_archivo_formulario', {
      id,
      coleccion
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export {
  crearDocumento,
  SubirArchivo,
  descargarDocumento,
  SubirArchivoFormulario,
  descargarDocumentoFormulario
}



// WEBPACK FOOTER //
// ./src/apiService/request/Documentos.js